import Button from "@mui/material/Button";
import FormGroup from "@mui/material/FormGroup";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { get, post } from "../../../../utils/api";
import SnackbarAlert from "../../../common/sanckbar";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";

function NewProductType() {
  const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState(false);
  const [alert_severity, setAlertSeverity] = useState("warning");
  const [alert_message, setMessage] = useState("");
  const [productCategories, setProductCategories] = useState<any>([]);

  useEffect(() => {
    getProductCategories();
  }, []);

  const getProductCategories = async () => {
    try {
      const response = await get("product_categories", { limit: 50 });

      if (response) {
        console.log("responseNew", response);
        setProductCategories(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [formData, setFormData] = useState({
    product_category_id: 0,
    product_type_name: "",
    del: 0,
    status_id: 1,
    status: "active",
  });

  const handleNewProduct = async (e: any) => {
    e.preventDefault();

    let productTypeDetails = {
      product_category_id: formData.product_category_id,
      product_type_name: formData.product_type_name,
      del: formData.del,
      status_id: formData.status_id,
      status: formData.status,
    };

    try {
      const response = await post("product_types", productTypeDetails);

      console.log(response.data);
      if (response) {
        alert("Product Type added successfully", "success");
        navigate("/product-types/list");
      }
    } catch (error) {
      console.log(error);
      alert("Something went wrong", "warning");
    }
  };

  const handleProductCategoryChange = (e: any) => {
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      product_category_id: e.product_category_id,
    }));
  };

  const handleChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  
  const alert = (message: string, alert_severity: string) => {
    setSnackbar(true);
    setMessage(message);
    setAlertSeverity(alert_severity);
  };

  const closeSnackbar = () => {
    // this.setState({ snackbar: false });
    setSnackbar(false);
  };

  return (
    <>
      <SnackbarAlert
        open={snackbar}
        closeSnackbar={closeSnackbar}
        message={alert_message}
        severity={alert_severity}
      />

      <div
        className="container"
        style={{ marginTop: "22px", paddingLeft: "20px" }}
      >
        <div className="row new-client-header">
          <div className="col-xs-12">
            <h5>New Product Type</h5>
          </div>
        </div>
        <form onSubmit={handleNewProduct} style={{ maxWidth: "1152px" }}>
          <div className="row mt-3 mb-3">
            <div className="col-xs-12 col-md-4 col-lg-4 d-flex align-items-center">
              <label htmlFor="productTypeName">Product Type Name</label>
            </div>
            <div className="col-xs-12 col-md-8 col-lg-8">
              <FormGroup>
                <TextField
                  sx={{ width: "100% !important" }}
                  fullWidth
                  required
                  id="productTypeName"
                  className="reg-input name-field"
                  name="product_type_name"
                  value={formData.product_type_name}
                  onChange={handleChange}
                  // error={Boolean(errorState.first_name)}
                  // helperText={errorState.first_name}
                  placeholder="Product Type Name"
                />
              </FormGroup>
            </div>
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-xs-12 col-md-4 col-lg-4 d-flex align-items-center">
              <label htmlFor="productCategory">Product Category</label>
            </div>
            <Autocomplete
              id="checkboxes-tags-demo"
              options={productCategories}
              style={{ width: 270, padding: "8px 7.5px" }}
              getOptionLabel={(option: any) => option.product_category}
              renderOption={(props, option) => (
                <li {...props}>{option.product_category}</li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Choose a product category"
                  placeholder="Product Category"
                />
              )}
              onChange={(event, selectedProductCategory) =>
                handleProductCategoryChange(selectedProductCategory)
              }
            />
          </div>

          <div className="d-flex justify-content-end">
            <Button
              variant="contained"
              type="submit"
              className="d-flex justify-content-end"
              style={{ marginBottom: "50px" }}
            >
              <span>Save</span>
            </Button>
          </div>
        </form>
      </div>
    </>
  );
}

export default NewProductType;
